module.exports = __webpack_public_path__ + "prizes-bg-show.79b324ab.png";